import { render, staticRenderFns } from "./TabSlider.vue?vue&type=template&id=7ce7cf4f&scoped=true"
import script from "./TabSlider.vue?vue&type=script&lang=js"
export * from "./TabSlider.vue?vue&type=script&lang=js"
import style0 from "./TabSlider.vue?vue&type=style&index=0&id=7ce7cf4f&prod&lang=scss&scoped=true"
import style1 from "./TabSlider.vue?vue&type=style&index=1&id=7ce7cf4f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce7cf4f",
  null
  
)

export default component.exports